import { useQuery } from '@tanstack/react-query'

import { fetchCourtOperatingHours } from '@/lib/venue/operatingHourApi'
import type { CourtOperatingHourView } from '@/lib/venue/operatingHourTypes'

export function courtOperatingHoursQueryKey(venueId: string, courtId: number) {
  return ['venue', venueId, 'courts', courtId, 'operating-hours'] as const
}

export function useCourtOperatingHours(venueId: string, courtId: number) {
  return useQuery<CourtOperatingHourView>({
    queryKey: courtOperatingHoursQueryKey(venueId, courtId),
    queryFn: () => fetchCourtOperatingHours(venueId, courtId),
  })
}
